import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';

import {LocalisationService} from './localisation.service';
import {LocalisationInfo} from '../../../class/api/LocalisationInfo';
import {LocalisationInfoItem} from '../../../class/api/LocalisationInfoItem';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {Subscription} from 'rxjs';

import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { LocalisationCancerComponent } from './localisation-cancer/localisation-cancer.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-localisations',
    templateUrl: './localisations.component.html',
    styleUrls: ['./localisations.component.scss'],
    providers: [],
    imports: [MatRadioGroup, FormsModule, MatRadioButton, LocalisationCancerComponent, MatButton, TranslateModule]
})
export class LocalisationsComponent implements OnInit, OnDestroy {
    translate = inject(TranslateService);
    locService = inject(LocalisationService);

    @Input() set passLocalisationInfo(
        value: LocalisationInfo
    ) {
        if (value) {
            setTimeout(() => {
                this.locService.localisationInfo = value;
            }, 0);
        }
    }

    @Input() public required = true;

    @Output() update: EventEmitter<LocalisationInfo> = new EventEmitter<
        LocalisationInfo
    >();

    private locServiceSub: Subscription = null;

    constructor() {
        this.locService.getLocalisation();
         this.locServiceSub = this.locService.observer.subscribe((res: LocalisationInfo) => {
            this.update.emit(res);
        });
    }

    public updateTypeLocalisation(event) {
        // Si "Localisation spécifique" et que pas de cancer on initialise un cancer vide;
        if (
            event == 2 &&
            !this.locService.localisationInfo.cancerPrimitifs.length
        ) {
            this.locService.localisationInfo.cancerPrimitifs.push(
                new LocalisationInfoItem()
            );
        } else {
            this.locService.localisationInfo.cancerPrimitifs = [];
            this.locService.save();
        }
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.locService.localisationInfo = null;
        this.locServiceSub.unsubscribe();
    }

    public isValid() {
        return this.locService.localisationInfoIsValid();
    }

    //Ne renverra que le tableau d'élément valide.
    public getData() {
        return this.locService.localisationInfo;
    }

}
